module.exports = __webpack_public_path__ + "static/media/573775ba-db66-4d5c-823f-09dfa78db616.1809cb2e.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/PDFFiles/573775ba-db66-4d5c-823f-09dfa78db616.pdf
// module id = 2567
// module chunks = 1